module.exports = __webpack_public_path__ + "static/img/39-3.0e85dfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/39-3.jpg
// module id = lzkb
// module chunks = 0